import {
  createUnifiedTheme,
  createBaseThemeOptions,
  palettes,
  genPageTheme,
} from '@backstage/theme';

const backstageCustomTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
        palette: {
        ...palettes.light,
        background: {
            default: '#f7f9f9',
        },
        // status: {
        //     ok: string;
        //     warning: string;
        //     error: string;
        //     running: string;
        //     pending: string;
        //     aborted: string;
        // };
        text: {
            primary: '#171717',
        },
        // bursts: {
        //     fontColor: string;
        //     slackChannelText: string;
        //     backgroundColor: {
        //         default: string;
        //     };
        //     gradient: {
        //         linear: string;
        //     };
        // };
        // primary: {
        //     main: '#0056a9',
        // },
        // secondary: {
        //     main: '#000000',
        // },
        // banner: {
        //     info: string;
        //     error: string;
        //     text: string;
        //     link: string;
        //     closeButtonColor: string;
        //     warning: string;
        // };
        // border: string;
        // textContrast: string;
        // textVerySubtle: string;
        // textSubtle: string;
        // highlight: string;
        // errorBackground: string;
        // warningBackground: string;
        // infoBackground: string;
        // errorText: string;
        // infoText: string;
        // warningText: string;
        // linkHover: string;
        // link: string;
        // gold: string;
        navigation: {
            background: '#171717',
            indicator: '#0056a9',
            color: '#f7f9f9',
            selectedColor: '#f7f9f9',
            navItem: {
                hoverBackground: '#0056a9',
            },
            submenu: {
                background: '#171717',
            },
        },
        // pinSidebarButton: {
        //     icon: string;
        //     background: string;
        // };
        // tabbar: {
        //     indicator: 'green',
        // },
        },
    },
    ),
    pageTheme : {
        home: genPageTheme({
            colors: ['#0056a9', '#000000'],
            shape: 'none',
            options: {
                fontColor: '#FFFFFF',
            },
        }),
        service: genPageTheme({
            colors: [ '#0056a9' , '#171717' ],
            shape: 'none',
            options: {
                fontColor: '#FFFFFF',
            },
        }),
        // logo: {
        //     component: LogoFull,
        // },
    }
});

export default backstageCustomTheme;
